// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__bVHeV","background":"styles_background__62iZm","white":"styles_white__OrmVD","line":"styles_line__ne3U4"};